/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {processInstrumentUnlinkEvents} from '../api'

export const useMutationProcessInstrumentUnlinkEvents = createReactQueryMutationHook('processInstrumentUnlinkEvents', processInstrumentUnlinkEvents)
